import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/nav/LOGO.png';
import _imports_1 from '@/assets/金币01.png';
import _imports_2 from '@/assets/金币02.png';
const _hoisted_1 = {
  class: "nav-wrap"
};
import { getWmsFormData } from "@/api/wms.js";
import Banner from "@/components/banner/index.vue";
import Connect from "@/components/connect/index.vue";
export default {
  __name: 'App',
  setup(__props) {
    const tabIndex = ref(0);
    const routerRef = ref();
    const router = useRouter();
    const route = useRoute();
    const bannerList = ref([]);
    getWmsFormData("wms-form-recruit-banner").then(res => {
      bannerList.value = res.data;
    });
    const go = (name, position, tab) => {
      tabIndex.value = tab;
      if (route.name == name) {
        routerRef.value.scroll && routerRef.value.scroll(position);
      } else {
        router.push({
          name,
          params: {
            position
          }
        });
      }
    };
    const mouseoverIndex = ref();
    let time = null;
    const mouseover = i => {
      mouseoverIndex.value = i;
      clearTimeout(time);
    };
    const mouseout = () => {
      time = setTimeout(() => {
        mouseoverIndex.value = tabIndex.value;
        // if (tabIndex.value) {
        //   mouseoverIndex.value = tabIndex.value;
        // } else {
        //   mouseoverIndex.value = route.name == "home" ? 0 : 2;
        // }
      }, 500);
    };
    const setIsFull = () => {
      if (document.documentElement.scrollTop < 50) {
        document.querySelector("body").dataset.isfull = true;
      } else {
        delete document.querySelector("body").dataset.isfull;
      }
    };
    onMounted(() => {
      setIsFull();
      setTimeout(() => {
        mouseoverIndex.value = route.name == "home" ? 1 : 3;
        window.addEventListener("scroll", e => {
          setIsFull();
        });
      }, 100);
      window.onbeforeunload = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      };
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("nav", null, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "img-box"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      })], -1)), _createElementVNode("ul", null, [_createElementVNode("li", {
        onMouseover: _cache[0] || (_cache[0] = $event => mouseover(1)),
        class: _normalizeClass({
          active: _unref(tabIndex) == 1 || _unref(tabIndex) == 0 && _ctx.$route.name == 'home',
          mouseover: _unref(mouseoverIndex) == 1
        }),
        onClick: _cache[1] || (_cache[1] = $event => go('home', '', 1)),
        onMouseout: _cache[2] || (_cache[2] = $event => mouseout())
      }, [...(_cache[15] || (_cache[15] = [_createTextVNode(" 首页 ", -1), _createElementVNode("div", null, null, -1)]))], 34), _createElementVNode("li", {
        onMouseover: _cache[3] || (_cache[3] = $event => mouseover(2)),
        onMouseout: _cache[4] || (_cache[4] = $event => mouseout()),
        onClick: _cache[5] || (_cache[5] = $event => go('home', '1', 2)),
        class: _normalizeClass({
          active: _unref(tabIndex) == 2,
          mouseover: _unref(mouseoverIndex) == 2
        })
      }, [...(_cache[16] || (_cache[16] = [_createTextVNode(" 成功案例 ", -1), _createElementVNode("div", null, null, -1)]))], 34), _createElementVNode("li", {
        onMouseover: _cache[6] || (_cache[6] = $event => mouseover(3)),
        onMouseout: _cache[7] || (_cache[7] = $event => mouseout()),
        onClick: _cache[8] || (_cache[8] = $event => go('policy', '1', 3)),
        class: _normalizeClass({
          active: _unref(tabIndex) == 3 || _unref(tabIndex) == 0 && _ctx.$route.name == 'policy',
          mouseover: _unref(mouseoverIndex) == 3
        })
      }, [...(_cache[17] || (_cache[17] = [_createTextVNode(" 分红政策 ", -1), _createElementVNode("div", null, null, -1)]))], 34), _createElementVNode("li", {
        onMouseover: _cache[9] || (_cache[9] = $event => mouseover(4)),
        onMouseout: _cache[10] || (_cache[10] = $event => mouseout()),
        onClick: _cache[11] || (_cache[11] = $event => go('policy', '2', 4)),
        class: _normalizeClass({
          active: _unref(tabIndex) == 4,
          mouseover: _unref(mouseoverIndex) == 4
        })
      }, [...(_cache[18] || (_cache[18] = [_createTextVNode(" 如何成为代理 ", -1), _createElementVNode("div", null, null, -1)]))], 34), _createElementVNode("li", {
        onMouseover: _cache[12] || (_cache[12] = $event => mouseover(5)),
        onMouseout: _cache[13] || (_cache[13] = $event => mouseout()),
        onClick: _cache[14] || (_cache[14] = $event => go('policy', '3', 5)),
        class: _normalizeClass({
          active: _unref(tabIndex) == 5,
          mouseover: _unref(mouseoverIndex) == 5
        })
      }, [...(_cache[19] || (_cache[19] = [_createTextVNode(" 常见问题 ", -1), _createElementVNode("div", null, null, -1)]))], 34)])])]), _createVNode(Banner, {
        bannerList: _unref(bannerList)
      }, null, 8, ["bannerList"]), _cache[21] || (_cache[21] = _createElementVNode("img", {
        class: "gold-1",
        src: _imports_1,
        alt: "",
        srcset: ""
      }, null, -1)), _cache[22] || (_cache[22] = _createElementVNode("img", {
        class: "gold-2",
        src: _imports_2,
        alt: "",
        srcset: ""
      }, null, -1)), _createVNode(Connect), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          ref_key: "routerRef",
          ref: routerRef
        }, null, 512))]),
        _: 1
      })], 64);
    };
  }
};